(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery-content-styles"] && !Shopify.designMode) return;
  try {
    /* Inner-zoom hover effect for product images + zoom indicator badge */
  function initInnerZoom() {
    var images = document.querySelectorAll('.product-information__media media-gallery slideshow-slide .product-media img');
    images.forEach(function (img) {
      var container = img.closest('.product-media');
      if (!container || container.dataset.zoomBound) return;
      container.dataset.zoomBound = '1';
      container.style.overflow = 'hidden';

      // Add zoom indicator badge (top-right corner)
      if (!container.querySelector('.pdp-zoom-badge')) {
        var badge = document.createElement('span');
        badge.className = 'pdp-zoom-badge';
        badge.setAttribute('aria-hidden', 'true');
        badge.innerHTML = '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="9" cy="9" r="6" stroke="currentColor" stroke-width="1.5"/><line x1="13.5" y1="13.5" x2="17" y2="17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
        container.appendChild(badge);
      }

      container.addEventListener('mouseenter', function () {
        img.style.transition = 'transform 0.2s ease';
        img.style.transformOrigin = '50% 50%';
      });

      container.addEventListener('mousemove', function (e) {
        var rect = container.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        img.style.transformOrigin = x + '% ' + y + '%';
        img.style.transform = 'scale(2)';
      });

      container.addEventListener('mouseleave', function () {
        img.style.transform = 'scale(1)';
        img.style.transformOrigin = '50% 50%';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInnerZoom);
  } else {
    initInnerZoom();
  }

  // Re-init when slides change (e.g., variant swap)
  var moInit = new MutationObserver(function () {
    initInnerZoom();
  });
  if (document.body) {
    moInit.observe(document.body, { childList: true, subtree: true });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var blocks = document.querySelectorAll('.product-details .text-block.rte');
    blocks.forEach(function (block) {
      var children = Array.from(block.children);
      children.forEach(function (el) {
        if (el.tagName !== 'P') return;
        var html = el.innerHTML;
        // Check if paragraph contains hyphen-prefixed lines
        if (!/(?:^|\n)\s*[-–—]\s/.test(html) && !/^<br\s*\/?>\s*[-–—]\s/.test(html)) return;
        // Split by <br> tags to get individual lines
        var lines = html.split(/<br\s*\/?>/i);
        var items = [];
        var before = [];
        var after = [];
        var inList = false;
        var done = false;
        lines.forEach(function (line) {
          var trimmed = line.trim();
          var match = trimmed.match(/^[-–—]\s+(.*)/);
          if (match && !done) {
            inList = true;
            items.push(match[1]);
          } else if (!inList) {
            before.push(trimmed);
          } else {
            done = true;
            after.push(trimmed);
          }
        });
        if (items.length === 0) return;
        var frag = document.createDocumentFragment();
        if (before.length > 0) {
          var text = before.filter(Boolean).join('<br>');
          if (text) {
            var p = document.createElement('p');
            p.innerHTML = text;
            frag.appendChild(p);
          }
        }
        var ul = document.createElement('ul');
        ul.className = 'pd-list';
        items.forEach(function (item) {
          var li = document.createElement('li');
          li.innerHTML = item;
          ul.appendChild(li);
        });
        frag.appendChild(ul);
        if (after.length > 0) {
          var text2 = after.filter(Boolean).join('<br>');
          if (text2) {
            var p2 = document.createElement('p');
            p2.innerHTML = text2;
            frag.appendChild(p2);
          }
        }
        el.parentNode.replaceChild(frag, el);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
